<div class="confirm">
  <div class="modal-title">{{ title }}</div>
  <div class="modal-body">
    <div class="message" [innerHTML]="message"></div>
    <div class="btn-container" [ngClass]="buttonAlignClass">
      <button
        class="modal-btn cancel"
        (click)="decline()"
        *ngIf="btnCancelText && btnCancelText !== ''"
      >
        {{ btnCancelText }}
      </button>
      <button
        class="modal-btn submit"
        (click)="accept()"
        *ngIf="btnOkText && btnOkText !== ''"
      >
        {{ btnOkText }}
      </button>
    </div>
  </div>
</div>
